import React, { Component } from "react";
import { Link } from "react-router-dom";

class FooterLinks extends Component {
  state = {
    socials: [
      { icon: "mdi mdi-facebook", link: "#" },
      { icon: "mdi mdi-linkedin", link: "#" },
      { icon: "mdi mdi-close", link: "#" },
      { icon: "mdi mdi-instagram", link: "#" },
    ],
  };

  render() {
    return (
      <ul className="pwlp-footer__socials">
        {this.state.socials.map((social, key) => (
          <li key={key}>
            <Link to={social.link} className="pwlp-footer__social-link">
              <i className={social.icon}></i>
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}

export default FooterLinks;